<template>
  <section class="">
    <h2 class="text-center text-orange" v-if="title" v-once>{{ title }}</h2>
    <div class="form-contact-content-scheduling">
      <form
        @submit.prevent="submit"
        style="width: 70%; margin: auto 15%"
        id="form-scheduling"
      >
        <slot name="form-top"></slot>
        <field
          :input="{ type: 'text', name: 'Origem', type: 'hidden'}"
          :value=origem
        />
        <field
          has-border
          is-small
          placeholder="Nome Completo"
          :input="{ type: 'text', name: 'Nome', required: 'required' }"
        />

        <field
          has-border
          is-small
          placeholder="E-mail"
          :input="{ type: 'email', name: 'Email', required: 'required' }"
        />

        <field
          has-border
          is-small
          placeholder="Telefone"
          :input="{ type: 'tel', name: 'Telefone', required: 'required' }"
        />

        <field
          has-border
          is-small
          placeholder="Selecionar Área desejada"
          :input="{ name: 'Area', required: 'required' }"
        >
          <template v-slot:default="{ changeFocus }">
            <select
              required
              v-model="Area"
              @focus="changeFocus(true)"
              name="Area"
            >
              <option v-for="(area, key) in areas" :key="key" :value="area.id">
                {{ area.name }}
              </option>
            </select>
          </template>
        </field>

        <field
          has-border
          is-small
          placeholder="Já é Cliente do Escritório?"
          :input="{ name: 'Cliente', required: 'required' }"
        >
          <template v-slot:default="{ changeFocus }">
            <select
              @focus="changeFocus(true)"
              v-model="Cliente"
              required
              name="Cliente"
            >
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </template>
        </field>

        <field
          has-border
          is-small
          placeholder="Motivo do Agendamento"
          :input="{ name: 'MotivoAtendimento', required: 'required' }"
        >
          <template v-slot:default="{ changeFocus }">
            <textarea
              name="MotivoAtendimento"
              required
              @blur="changeFocus(false)"
              @focus="changeFocus(true)"
            ></textarea>
          </template>
        </field>

        <field
          has-border
          is-small
          placeholder="Data do Atendimento"
          :input="{ name: 'Data', required: 'required' }"
        >
          <template v-slot:default="{ changeFocus }">
            <select
              required
              v-model="Data"
              name="data"
              id="data"
              class="form-control"
              tabindex="12"
              @focus="changeFocus(true)"
              @change="getHours($event)"
            >
              <option v-for="(date, key) in datas" :key="key" :value="date.id">
                {{ date.text }}
              </option>
            </select>
          </template>
        </field>

        <field
          has-border
          is-small
          placeholder="Horário do Atendimento?"
          :input="{ name: 'Data', required: 'required' }"
        >
          <template v-slot:default="{ changeFocus }">
            <select
              v-model="DataAtendimento"
              name="DataAtendimento"
              id="DataAtendimento"
              class="form-control"
              tabindex="12"
              @focus="changeFocus(true)"
              required
            >
              <option
                v-for="(hora, key) in horarios"
                :key="key"
                :value="hora.id"
              >
                {{ hora.text }}
              </option>
            </select>
          </template>
        </field>

        <p class="text-center">
          <button
            type="submit"
            class="button button-orange"
            :disabled="buttonSubmited"
          >
            ENVIAR
          </button>
        </p>
      </form>
      <aside class="form-contact-info">
        <slot name="info"></slot>
      </aside>

      <modal :active.sync="modalContactIsOpen">
        <div class="text-center">
          <h3>Agendamento realizado com sucesso!</h3>
        </div>
      </modal>
    </div>
  </section>
</template>

<script>
import Field from "./Field";
import api from "../services/api";
import qs from "querystring";
import Modal from "@/components/Modal";

export default {
  components: { Field, Modal },
  props: {
    title: String,
    origem: String,
  },

  data() {
    return {
      Nome: "",
      Email: "",
      Telefone: "",
      Area: "",
      Cliente: "",
      DataAtendimento: "",
      MotivoAtendimento: "",
      Data: null,
      datas: [],
      horarios: [],
      modalContactIsOpen: false,
      areas: [],
      buttonSubmited: false,
    };
  },

  async created() {
    await this.getDates();
    await this.getAreas();
  },

  methods: {
    async getDates() {
      const { data: data } = await api.get("online-scheduling/dates");
      this.datas = data.datas;
    },

    async getHours(event) {
      const { data: data } = await api.get(
        "online-scheduling/hours?date=" + event.target.value
      );
      this.horarios = data.hours;
    },

    async getAreas() {
      const { data: areas } = await api.get("contact/areas?online=true");
      this.areas = areas;
    },

    async submit() {
      this.buttonSubmited = true;

      try {
        // var form = document.getElementById("form-scheduling");
        var nome = document.querySelector('[name="Nome"]').value;
        var email = document.querySelector('[name="Email"]').value;
        var telefone = document.querySelector('[name="Telefone"]').value;
        var data = document.querySelector('[name="DataAtendimento"]').value;
        var area = document.querySelector('[name="Area"]').value;
        var cliente = document.querySelector('[name="Cliente"]').value;
        var motivo = document.querySelector('[name="MotivoAtendimento"]').value;
        var origem = document.querySelector('[name="Origem"]').value;

        const requestBody = {
          Nome: nome,
          Email: email,
          Telefone: telefone,
          DataAtendimento: data,
          AreaContatoId: area,
          Clinte: cliente,
          MotivoAtendimento: motivo,
          Origem: origem,
        };

        await api
          .post("/online-scheduling", qs.stringify(requestBody))
          .then(() => {
            this.modalContactIsOpen = true;
          })
          .catch(() => {
            alert(
              "Aconteceu um erro no envio de seu agendamento, Para mais dúvidas, ligue para (11) 3376-0100"
            );
          });
      } finally {
        this.buttonSubmited = false;
      }
    },
  },
};
</script>

<style>
</style>
